/**
 * G3 — o ECO da entrada do formulário de metas. Nada aqui calcula métrica (invariante 3):
 * só converte o que a pessoa digitou para a unidade inteira que o servidor guarda, e de volta.
 * Campo vazio é "sem meta" (`null`) — nunca zero.
 */
import { apenasDigitos, centavosDeDigitos, mascaraDeCentavos } from '../earnings/earnings-ui';

export { apenasDigitos, mascaraDeCentavos };

/** Percentual digitado ("20", "20,5", "20.5%") → pontos-base (2000, 2050). Vazio → null. */
export function bpDePercentual(entrada: string): number | null {
  const limpo = entrada.replace('%', '').replace(',', '.').trim();
  if (limpo === '') return null;
  if (!/^\d{1,3}(\.\d{1,2})?$/.test(limpo)) return Number.NaN;
  return Math.round(Number(limpo) * 100);
}

/** Pontos-base → o que o campo mostra ("20", "20,5"). */
export function percentualDeBp(bp: number | null): string {
  if (bp === null) return '';
  return (bp / 100).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
}

/** Dígitos de dinheiro (todo dígito é centavo) → centavos. Vazio → null. */
export function centavosDoCampo(digitos: string): number | null {
  return centavosDeDigitos(digitos);
}

/** Centavos → dígitos do campo de dinheiro. */
export function digitosDeCentavos(centavos: number | null): string {
  return centavos === null ? '' : String(centavos);
}

/*
 * Lucro por lead tem 4 casas (R$ 0,0500): todo dígito é 1/10 000 de real = 10 milésimos de
 * centavo, a unidade do servidor (`lead-profit.ts`).
 */
const MILICENTAVOS_POR_DIGITO = 10;

export function milicentavosDoCampo(digitos: string): number | null {
  const limpos = apenasDigitos(digitos).slice(0, 7);
  if (limpos.length === 0) return null;
  return Number(limpos) * MILICENTAVOS_POR_DIGITO;
}

export function digitosDeMilicentavos(m: number | null): string {
  return m === null ? '' : String(Math.round(m / MILICENTAVOS_POR_DIGITO));
}

/** `500` → "0,0500" (o que o campo mostra enquanto a pessoa digita). */
export function mascaraDeLucro(digitos: string): string {
  const m = milicentavosDoCampo(digitos);
  if (m === null) return '';
  return (m / 100_000).toLocaleString('pt-BR', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
}
